import { useMemo } from 'react'
import { useDagProgram } from './useDagProgram'
import { initializeLightClient } from '~/programs/lightClient'

export function useLightClient() {
  const { program } = useDagProgram()

  const client = useMemo(() => {
    if (!program) return null
    return initializeLightClient(program)
  }, [program])

  return { client }
}
